<template>
  <div id="related-manuscripts">
    <div class="mar-b-20 ipub-tab-list">
      <!-- <span :class="['ipub-p1','ipub-cursor-pointer','ipub-tab-list--tab',titleIndex===index?'active':'']"
            style="min-width:235px"
            v-for="(item,index) in titleTab"
            :key="item+index"
            @click="changeTitle(index)">{{item}}</span> -->
      <span @click="changeTitle('SUBMITED')"
            v-if="roleType.includes('AUTHOR')"
            style="min-width:235px"
            :class="['ipub-p1','ipub-cursor-pointer','ipub-tab-list--tab',titleIndex==='SUBMITED'?'active':'']">Submissions</span>
      <span @click="changeTitle('REPORTS')"
            v-if="roleType.includes('REVIEWER')||roleType.includes('REVIEWER_BOARD')"
            style="min-width:235px"
            :class="['ipub-p1','ipub-cursor-pointer','ipub-tab-list--tab',titleIndex==='REPORTS'?'active':'']">Reports</span>
      <span @click="changeTitle('DECISION')"
            v-if="roleType.includes('EDITORIAL_BOARD')||roleType.includes('GUEST_EDITOR')||roleType.includes('TOPIC_EDITOR')"
            style="min-width:235px"
            :class="['ipub-p1','ipub-cursor-pointer','ipub-tab-list--tab',titleIndex==='DECISION'?'active':'']">Decisions</span>
    </div>
    <ipub-row :gutter="12"
              v-if="titleIndex ==='REPORTS' || titleIndex ==='DECISION'">
      <ipub-col :span="6">
        <div class="mar-b-10 ipub-p1">
          <span>Invite Time</span>
          <!--  :type="isActive==='all'?'default':''" -->
          <!-- :type="isActive==='day'?'default':''" -->
          <ipub-label :cover="isActive==='all'"
                      style="color:#1E1D40"
                      class="mar-l-10 ipub-c-p"
                      circle
                      @click="searchList('all')">All</ipub-label>
          <ipub-label :cover="isActive==='day'"
                      style="color:#1E1D40"
                      class="mar-l-10 ipub-c-p"
                      circle
                      @click="searchList('day')">Last 60 Days</ipub-label>
        </div>
      </ipub-col>
    </ipub-row>
    <div>
      <ipub-table :columns="columns[titleIndex]"
                  :pagination="false"
                  :dataSource="dataSource">
        <template v-slot:status="{text}">
          <span v-if="titleIndex==='SUBMITED'">{{text ? articalStatus[text] : '--'}}</span>
          <span v-else-if="titleIndex==='REPORTS'">{{text ? reviewerStatus[text]:'--'}}</span>
          <span v-else-if="titleIndex==='DECISION'">{{text ? academicStatus[text]:'--'}}</span>
        </template>
        <template v-slot:rating="{text}">
          {{text ? rating[text]:'--'}}
        </template>
        <template v-slot:decision="{text,record}">
          <span v-if="titleIndex==='SUBMITED'">{{text ? articalStatus[text]:'--'}}</span>
          <span v-else-if="titleIndex==='REPORTS'">{{text ? articalStatus[text]:'--'}}</span>
          <span class="ipub-c-p link-color"
                v-else-if="titleIndex==='DECISION'"
                @click="linkTo(record)">{{text ? decisionStatus[text]:'--'}}</span>
        </template>
        <template v-slot:spend="{record}">
          <div>
            <span class="fw-bd">{{(record.invitedTime && record.statusTime) ? $moment(record.statusTime ).diff($moment(record.invitedTime),'days')+1:'--'}}</span>
            <span class="mar-l-4">({{record.statusTime ? $moment(record.statusTime).format('HH : mm DD / MM / YYYY'):'--'}})</span>
          </div>
        </template>

      </ipub-table>
    </div>
  </div>
</template>

<script>
import main from './main'
export default main
</script>

<style lang="scss" scoped>
#related-manuscripts {
}
</style>
